import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import Img from 'gatsby-image';
import { graphql, useStaticQuery } from 'gatsby';

import { Button } from './Button';
import device from '../utils/device';

const Container = styled.div`
  background-color: white;
  text-align: center;
  padding: 3rem 1rem;
  overflow-x: hidden;

  p {
    font-size: 20px;
    line-height: 1.8rem;
  }
`;
const CenterDiv = styled.div`
 text-align: center;
 margin: 1rem 0;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;

  @media ${device.desktop} {
    width: 75vw;
  }
`;

const Column = styled.div`
  flex-basis: 100%;
  @media ${device.desktop} {
    flex-basis: 33%;
  }
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.textDark};
  font-weight: 700;
  margin-bottom: 1rem;

  font-size: 1.5rem;
`;

const Subtitle = styled.div`
  color: #1e1a1a;
  margin-bottom: 2rem;
  font-size: 17px;
`;

const H3 = styled.h3`
  font-size: 20px;
  height: 4rem;
  margin-bottom: 2rem;
  padding: 0 1rem;
`;

const PositionedButton = styled(Button)`
  margin: 1rem auto 0;
`;

const ImgNegativeMargin = styled(Img)`
  margin: 0 -3rem;
  @media ${device.desktop} {
    margin: 0 -3rem;
  }
`;

const ValueBadge = styled.div`
  border-radius: 4px;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.colors.actionSecondary};
  color: white;
  text-transform: uppercase;
  font-size: 19px;
  display: inline-block;
  margin: -2rem 0 3rem;
  position: relative;
`;

const Bonuses = () => {
  const { laptopLeft, laptopRight, laptopFront } = useStaticQuery(graphql`
    query {
      laptopLeft: file(relativePath: { eq: "laptop_left.png" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      laptopRight: file(relativePath: { eq: "laptop_right.png" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      laptopFront: file(relativePath: { eq: "laptop_front.png" }) {
        childImageSharp {
          fluid(maxWidth: 1600) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  const theme = useContext(ThemeContext);
  return (
    <Container>
      <Title>Bonuses</Title>
      <Subtitle>
        In addition to lifetime access to this life-changing program,
        <br /> you will also receive the following three bonuses:
      </Subtitle>
      <Row>
        <Column>
          <H3>
          The Stillness of Being workshop from Hameed on the Black Latifa
          </H3>
          <ImgNegativeMargin fluid={laptopLeft.childImageSharp.fluid} />
          <ValueBadge>Value $90</ValueBadge>
        </Column>
        <Column>
          <H3>
          Highlights from Conscious Life’s Trauma Super Conference including Gabor and Hameed’s interviews as well as others
          </H3>
          <Img fluid={laptopFront.childImageSharp.fluid} />
          <ValueBadge>Value $30</ValueBadge>
        </Column>
        <Column>
          <H3>1-year access to Conscious Life including 400+ online courses and multiple trainings on the the Diamond Approach</H3>
          <ImgNegativeMargin fluid={laptopRight.childImageSharp.fluid} />
          <ValueBadge>Value $180</ValueBadge>
        </Column>
      </Row>
      <CenterDiv>
          <p>
          <strong>
            Lifetime access to recordings, along with closed captions and
            transcripts will be given to all who purchase.
          </strong>{' '}
          </p>
          {/* If you attend live you may have the opportunity to ask questions, but
          you do not need to attend live to get maximum benefit from this
          program. */}
        </CenterDiv>
      <Row>
        <PositionedButton
          to="#payment-options"
          variant="solid"
          size="SM"
          color={theme.colors.actionPrimary}
        >
          Click here to register
        </PositionedButton>
      </Row>
    </Container>
  );
};

export default Bonuses;
